import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const emission_detail_options = apiUrl + "/emission_detail_options";
const routes = {
  label: "Emission Detail Options",
  root: emission_detail_options,
  get_all: emission_detail_options + "/get_all",
  search: emission_detail_options + "/search",
};

export const Emission_Detail_Options = {
  getAll: () => getWithToken(routes.get_all),
  searchMaterials: (search_term) => postWithToken(routes.search, { search_term }),
};
